import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import classNames from "classnames";

import lockViewport from "utils/lockViewport";
import Sidekick from "components/library/Sidekick";
import TypeaheadPill from "./TypeaheadPill";

import "react-select/dist/react-select.css";
import dropdownStyles from "components/library/Dropdown/Dropdown.css";
import styles from "./Typeahead.css";

export default function Typeahead({ className, ...props }) {
  const inputProps = {
    autoCorrect: "off",
    spellCheck: "false",
    className: styles.input,

    // react-autorsize-input has a race condition where it computes the size of the text in the input before the styles get loaded so just hardcode it.
    inputstyle: { fontSize: 13 },

    // Pass in the inputId prop so <label> can focus the input.
    id: props.inputId,
  };

  return (
    <div className={styles.relativeRoot} onTouchStart={lockViewport}>
      <Select.Async
        inputProps={inputProps}
        className={classNames(styles.root, dropdownStyles.root, className, {
          [styles.hideSpinningIcon]: props.hideSpinningIcon,
          [styles.error]: !!props.error,
        })}
        multi={true}
        optionClassName={styles.option}
        noResultsText={null}
        searchPromptText={null}
        loadingPlaceholder={null}
        clearable={false}
        valueComponent={TypeaheadPill}
        arrowRenderer={null}
        aria-invalid={!!props.error}
        openOnClick={false}
        {...props}
      />
      {!!props.error && (
        <Sidekick hasError title={props.error.title}>
          {props.error.message ||
            (Array.isArray(props.error) && props.error[0]) ||
            props.error}
        </Sidekick>
      )}
    </div>
  );
}

// This component can take all the same props as react-select but these are required for render.
Typeahead.propTypes = {
  className: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.instanceOf(Error),
  ]),
  hideSpinningIcon: PropTypes.bool,
  inputId: PropTypes.string.isRequired,
  loadOptions: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array,
  renderArrow: PropTypes.bool,
};
